import { MAX_ASSET_TRACKS } from '@casops/store/slices/assetTracksSlice';

export const LEAFLET_DEFAULT_PANE_ZINDEX = 400;

export enum LeafletPaneName {
  tile = 'tile',
  overlay = 'overlay',
  shadow = 'shadow',
  marker = 'marker',
  tooltip = 'tooltip',
  popup = 'popup',
}

export const LeafletPaneZIndex: Record<LeafletPaneName, number> = {
  [LeafletPaneName.tile]: 200,
  [LeafletPaneName.overlay]: 400,
  [LeafletPaneName.shadow]: 500,
  [LeafletPaneName.marker]: 600,
  [LeafletPaneName.tooltip]: 650,
  [LeafletPaneName.popup]: 700,
};

export const TRACKS_PANE_ZINDEX = LeafletPaneZIndex.overlay + 1; // Always above other overlays (geofences, etc).
export const SHAPE_EDITOR_PANE_ZINDEX = TRACKS_PANE_ZINDEX + MAX_ASSET_TRACKS + 1; // Always above the tracks.

export const OVERLAY_PORTAL_ID = 'shape-editor-overlay-portal';
export const TRACKS_PANE_NAME = 'tracksPane';
export const SHAPE_EDITOR_PANE_NAME = 'shapeEditorPane';

export const GEOFENCE_EDITOR_LAYER_CLASS = 'geofence-editor-layer';
